// extracted by mini-css-extract-plugin
module.exports = {"envelopeIcon":"EnvelopeIcon__envelopeIcon___EP73J"};